import React from 'react';
import { Table } from 'reactstrap';

export const TsuValidityModal = {
  title: 'Tsunami Event Validity',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>-1 to 4</b>
      </div>
      <br />
      <p>Validity of the actual tsunami occurrence is indicated by a numerical rating of the reports of that event:</p>
      <Table size="sm">
        <tbody>
          <tr>
            <th scope="row">-1</th>
            <td>erroneous entry</td>
          </tr>
          <tr>
            <th scope="row">0</th>
            <td>event that only caused a seiche</td>
          </tr>
          <tr>
            <th scope="row">1</th>
            <td>very doubtful tsunami</td>
          </tr>
          <tr>
            <th scope="row">2</th>
            <td>questionable tsunami</td>
          </tr>
          <tr>
            <th scope="row">3</th>
            <td>probable tsunami</td>
          </tr>
          <tr>
            <th scope="row">4</th>
            <td>definite tsunami</td>
          </tr>
        </tbody>
      </Table>
    </div>
  ),
};
